import { doc, cursor, scrl, getPosition, inViewport, registeredLoops, lenisScrollTo, stopLenis, startLenis, touchDevice } from './../../js/utils/events.js';
import { map } from './../../js/utils/math.js';

export default class imageSticker {
  init(root) {
    this.root = root //is an arrray
    this.parallaxSpeed = this.root.dataset.parallaxSpeed;

    if(this.parallaxSpeed != 1) {
      registeredLoops.push({ //add this.loop to global requestAnimationFrame
        root: this.root,
        component: this,
        position: getPosition(this.root),
        loop: this.loop
      })
    }
    // console.log(registeredLoops)
  }

  loop(time) {
    // console.log(scrl)
    const inView = inViewport(this.position)
    // console.log(inView)
    // console.log(inView)
    
    
    this.maxOffset = map(this.component.parallaxSpeed, 1, 2, 0, -doc.h)
    
    if(inView.loopback === 1) {
      this.root.style.transform = `translate3d(0, ${map(inView.progress, 0, 1, 0, this.maxOffset)}px, 0)`;
    }
    // if(inView.loopback === 1) {
    //   this.root.classList.add('fade-in')
    // } else {
    //   this.root.classList.remove('fade-in')
    // }
  }
}

